import React from "react";
import TextButton from "./buttons/TextButton";
import { useNavigate } from "react-router-dom";


const GameStartButtons = (props) => {
    const navigate = useNavigate();
    const openGame = (initialData) => {
        navigate(process.env.PUBLIC_URL + "/game/" + props.gameType.name + "?" + new URLSearchParams({initialData: initialData}));
    };
    return ( <div className="flexCenter marginTop1">
            <TextButton textKey="button.pliksPlaks" className='marginRight1' onClick={() => openGame("random")}></TextButton>
            <TextButton textKey="button.chooseNumbers" className='marginLeft1' onClick={() => openGame("empty")}></TextButton>
        </div>)
 
};

export default GameStartButtons;